import actions from './actions'

const task = (state = { taskSelectedItems: { } }, action) => {
  switch (action.type) {
    case actions.setTask:
      return { ...state, taskSelectedItems: action.taskSelectedItems }
    default:
      return state
  }
}
export default task
